import { FileInput, Label } from "flowbite-react";
import React, { ChangeEvent } from "react";
import { UploadSolidIcon } from "../icon/UploadSolidIcon";
import { Body16Underline } from "../typography/Body16Underline";
import { Footnote12Description } from "../typography/Footnote12Description";

interface Props {
  onFileChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const ImageFileInput: React.FC<Props> = ({ onFileChange }) => (
  <Label
    htmlFor="dropzone-file"
    className="absolute inset-0 flex flex-col items-center justify-center cursor-pointer bg-grayscale-contrast-2"
  >
    <UploadSolidIcon size={40} color="text-grayscale-contrast-40" />
    <Body16Underline className="my-[8px] text-semantic-text-secondary">
      이 곳을 클릭해 파일을 업로드해주세요.
    </Body16Underline>
    <Footnote12Description className="text-semantic-text-secondary">
      권장 용량: 10mb / 권장 해상도: 768x427px
    </Footnote12Description>
    <FileInput id="dropzone-file" className="hidden" onChange={onFileChange} />
  </Label>
);
